/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var InputChangeEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(InputChangeEventArgs, _super);
    function InputChangeEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._isCompositionInProgress = false;
        return _this;
    }
    Object.defineProperty(InputChangeEventArgs.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (a) {
            this._value = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputChangeEventArgs.prototype, "isCompositionInProgress", {
        get: function () {
            return this._isCompositionInProgress;
        },
        set: function (a) {
            this._isCompositionInProgress = a;
        },
        enumerable: true,
        configurable: true
    });
    InputChangeEventArgs.$t = markType(InputChangeEventArgs, 'InputChangeEventArgs', EventArgs.$);
    return InputChangeEventArgs;
}(EventArgs));
export { InputChangeEventArgs };
//# sourceMappingURL=InputChangeEventArgs.js.map
